module.exports = __webpack_public_path__ + "images/init-notification-1c8665856f8ea5769dc5fa7c387076f4.png";